﻿import React from "react";
import LazyLoad from 'react-lazyload';

interface ProductFeatureImageProps {
    imageLocation: string; //Would be equivalent to ImageLocation on the DynoFeaturemodel
    imagePath: string;
    altText: string;
}

const ProductFeatureImage = (props: ProductFeatureImageProps) => {     
        return (
            <LazyLoad once>
                <img src={props.imagePath} alt={props.altText} />
            </LazyLoad>
        )
}

export default ProductFeatureImage;